module.exports = __webpack_public_path__ + "static/media/courses.f4d2d18a.svg";